import React from 'react';
import { useStyles } from "../styles";
import Button from "@mui/material/Button";
import Avatar from "@mui/material/Avatar";
import UserIcon from "../../../assets/header/userIcon.svg";
import WppIcon from "../../../assets/header/wppIcon.png";
import NotificationIcon from "../../../assets/header/notify.svg";
import { useCallback, useMemo, useState } from "react";
import { useAuth } from "../../../hooks/useAuth";
import ProfileMenu from "../ProfileMenu";
import { isLocalhost } from "../../../utils/constants";
import { useNavigate } from "react-router-dom";
import Badge from "@mui/material/Badge";
import { listNotification } from "../../../services/notifications";
import { useQuery } from "react-query";
import { Notification as TNotification } from "../../../types/notification";

/* type Permission = {
  moduleId: number;
  moduleName: string;
  serviceId: number;
  serviceName: string;
}; */


export type RedirectOptions =
  | "home"
  | "dashboard"
  | "financial"
  | "minhaConta"
  | "studio"
  | "projects"
  | "newStudio"
  | "professional"
  | "criar_arte"
  | "allApps"
  | "radios"
  | "campanhas"
  | "site"
  | "whatsapp"
  | "redes_sociais"
  | "sair";

export function RightHeader() {
  const { signOut, token } = useAuth();
  const navigate = useNavigate();

  const styles = useStyles();
  const [profileMenuAnchorEl, setProfileMenuAnchorEl] =
    useState<HTMLElement | null>(null);

  const handleProfileMenuOpen = (event: React.MouseEvent<HTMLElement>) =>
    setProfileMenuAnchorEl(event.currentTarget);
  const handleProfileMenuClose = () => setProfileMenuAnchorEl(null);

  const notifications = useQuery("notifications", listNotification, {
    refetchOnWindowFocus: "always",
  });

  const unread: TNotification[] = useMemo(() => {
    return notifications.data?.filter((data) => !Boolean(data.read)) || [];
  }, [notifications.data]);

  const handleGoToDsV3 = useCallback(
    (option: RedirectOptions) => {
      const alias = isLocalhost
        ? "https://app.dsmarketing.com.br"
        : "https://app.dsmarketing.com.br";
      const urlDsV2 = ` ${alias}/sign-as-user/${token}?shortToRedirect=${option}`;
      window.location.assign(urlDsV2);
    },
    [token]
  );

  const handleSignOut = useCallback(() => {
    signOut();
    handleGoToDsV3("sair");
    // navigate("/");
  }, [handleGoToDsV3, signOut]);

  const handleGoToYouTube = () => {
    window.open("https://www.youtube.com/watch?v=v9PBKqKHP2s")
  }

  const handleRedirectToSuport = () => {
      const user = localStorage.getItem('@datasales:user') ?? '';
      const parsedUser = JSON.parse(user);
      const companyName = parsedUser.companyName;
      const companyDocument = parsedUser.companyDocument;
      const companyEmail = parsedUser.email;
    
    window.open(`https://api.whatsapp.com/send?text=Ol%C3%A1%2C+sou+da+empresa+${companyName}%2C+aqui+est%C3%A1+meu+CNPJ%3A+${companyDocument}+e+meu+EMAIL%3A+${companyEmail}+Estou+precisando+de+ajuda%21&phone=551131810653

    `);
  };

  const handleNotificationMenuOpen = useCallback(() => {
    navigate("/notification");
  }, [navigate]);

  /* function hasPermitions(module: string, permit: string) {
    const userPermissions = JSON.parse(
      localStorage.getItem("@datasales:permissions") || "{}"
    );
    let permission = userPermissions[module]?.find((permission: Permission) =>
      permission.serviceName.includes(permit)
    );
    if (!permission) {
      permission = userPermissions?.find((permission: any) =>
        permission.service.name.includes(permit)
      );
    }
    return Boolean(permission);
  } */

  return (
    <div className={styles.rootLeft} id="header-block-right">
      <Button
        onClick={handleGoToYouTube}
        id="btn-new-campaigns"
        className={styles.btn}
        sx={{
          borderRadius: '4.75rem', 
          backgroundColor: "#2A3364",
          color: "#FFFFFF",
          paddingLeft: "20px",
          paddingRight: "20px",  
        }}
      >
        Aprenda o novo menu
      </Button>

      <Button
        onClick={handleRedirectToSuport}
        id="btn-new-campaigns"
        className={styles.btn}
        sx={{
          borderRadius: '4.75rem', 
          backgroundColor: "#2A3364",
          color: "#FFFFFF",
          paddingLeft: "20px",
          paddingRight: "20px",  
        }}
      >
      <img src={WppIcon} alt="falar com suporte" className={styles.wppImg} />
        Falar com suporte
      </Button>

      <Badge badgeContent={unread.length} color="primary">
        <Avatar
          id="notification"
          src={NotificationIcon}
          onClick={handleNotificationMenuOpen}
          style={{
            width: "24px", 
            height: "24px",
            alignItems: "center",
            cursor: 'pointer'
          }}
        />
      </Badge>

      <Avatar
        id="avatar"
        className={styles.avatar}
        src={UserIcon}
        onClick={handleProfileMenuOpen}
        style={{
          width: "24px", 
          height: "24px",
          marginLeft: '1rem',
          cursor: 'pointer',
          marginRight: '1rem'
        }}
      />

      <ProfileMenu
        anchorEl={profileMenuAnchorEl}
        onClose={handleProfileMenuClose}
        handleSignOut={handleSignOut}
      />
    </div>
  );
}
